export default "__VITE_ASSET__C78JWbNr__$_?url__"